import { logger } from '../utils/logger/loggerInstance';

export function useLogger(scope?: string) {
  return {
    debug: (msg: string, context?: object) =>
      logger.debug(scope ? `[${scope}] ${msg}` : msg, context),

    info: (msg: string, context?: object) =>
      logger.info(scope ? `[${scope}] ${msg}` : msg, context),

    warn: (msg: string, context?: object) =>
      logger.warn(scope ? `[${scope}] ${msg}` : msg, context),

    error: (msg: string, context?: object) =>
      logger.error(scope ? `[${scope}] ${msg}` : msg, context),
  };
}
